/**
 * @module lib/calculate-max-loan
 */
import { getDiscountFactor } from './amortize';
/**
 * Calculates the maximum loan assuming no mortgage insurance
 * @param {object} data
 * @param {number} data.annualInterestRate Annual interest rate in percent
 * @param {number} data.monthlyMortgagePayment Maximum monthly housing payment
 * @param {number} data.loanTermMonths Loan term in months
 * @returns {number}
 */

export default (function (_ref) {
  var annualInterestRate = _ref.annualInterestRate,
      monthlyMortgagePayment = _ref.monthlyMortgagePayment,
      loanTermMonths = _ref.loanTermMonths;
  return getDiscountFactor({
    annualInterestRate: annualInterestRate,
    loanTermMonths: loanTermMonths
  }) * monthlyMortgagePayment;
});